import script from "./games-filter-desktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./games-filter-desktop.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__